<!-- =========================================================================================
  File Name: ListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">

    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @getdata="getdata" @closeSidebar="toggleDataSidebar" :data="sidebarData" />
    <!-- ADD NEW -->
    <div>
    <vs-button class="user_add_btn" type="filled" @click="addNewData"><feather-icon icon="PlusIcon" class="flex-inline" svgClasses="h-3 w-3" /> New Schedule</vs-button>
      <!-- <vs-button class="user_add_btn" radius icon="icon-plus" icon-pack="feather"    @click="addNewData"/> -->
    </div>
    <vs-table ref="table"  pagination :max-items="itemsPerPage" search :data="schedules">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

          <!-- ACTION - DROPDOWN -->
          <vs-dropdown v-if="selected.length>0" vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

            <div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Delete</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Archive</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Print</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Another Action</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>

          <!-- ADD NEW -->
<!--          <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewData">-->
<!--              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />-->
<!--              <span class="ml-2 text-base text-primary">Add New</span>-->
<!--          </div>-->
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ schedules .length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : schedules.length }} of {{ queriedSchedules }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-checkbox></vs-checkbox>
        <vs-th sort-key="name">Name</vs-th>
        <vs-th sort-key="name">Schedules</vs-th>
        <vs-th>Action</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td><vs-checkbox  @input="SelectItem(tr.id)"></vs-checkbox></vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.name }}</p>
            </vs-td>
            <vs-td>
              <p v-for="scheduledate in tr.scheduledates" :key="scheduledate.id">
                <span>
                {{ scheduledate.day + ' : '}}
                {{ scheduledate.start_time | formatDate }}   {{ scheduledate.end_time | formatDate }}
                </span>
              </p>
            </vs-td>
            <!-- <vs-td>
              <p class="product-name font-medium truncate" :key="dayname" v-for="(dayData, dayname) in main.dates">
             <span :key="skey" v-for="(sheduleData, skey) in dayData">
             <span v-if="sheduleData.start_time != ''">
                     {{ dayname + ' : '}}
                {{ sheduleData.start_time }}   {{ sheduleData.end_time }}
                  </span></span></p>
             </vs-td> -->
            <vs-td class="whitespace-no-wrap">
              <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer">
                <div>
                    <feather-icon icon="MoreVerticalIcon" @click.stop="" svgClasses="w-6 h-6 hover:text-primary stroke-current" class="ml-2" />
                </div>
                 <vs-dropdown-menu>
                 <vs-dropdown-item>
                <span class="flex items-center" @click="editData(tr)">
                  <feather-icon icon="EditIcon" svgClasses="h-4 w-4" class="mr-2"/>
                  <span> Edit </span>
                </span>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                <span class="flex items-center" @click="confirmDeleteRecord(tr)">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2 "/>
                  <span>Delete</span>
                </span>
                </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>

            </vs-td>

          </vs-tr>
          </tbody>
        </template>
    </vs-table>
  </div>
</template>

<script>
import {ALL_SCHEDULE,REMOVE_SCHEDULE,UPDATE_SCHEDULE} from '@/graphql'
import DataViewSidebar from './addSidebarView.vue'
import moduleDataList from '@/store/data-list/moduleDataList.js'
import moment from 'moment'


export default {
  components: {
    DataViewSidebar,
    moment

  },
  data () {
    return {
      selected: [],
      schedules:[],
      // products: [],
      itemsPerPage: 4,
      isMounted: false,
      deletedschedules:[],
      // Data Sidebar
      addNewDataSidebar: false,
      addNewCamUserSidebar: false,
      sidebarData: {},
      camUserSidebarData : {},
      DeletedItem:'',
    }
  },
  filters: {
  formatDate: function (value) {
    if (value) {
    return moment(String(value),'h:mm A').format('h:mm A')
  }
  }
},
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    products () {
      return this.$store.state.dataList.products
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.products.length
    },
    // schedules () {
    //   return this.$store.state.dataList.schedules
    // },
    queriedSchedules () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.schedules.length
    }
  },
  methods: {
    getdata(value){
     if(value){
       this.get()
     }
     },
    SelectItem(id){
      var status=false
    for (var i = 0; i < this.selected.length; i++) {
    if (this.selected[i] == id) {
       status=true
    }
  }
  if(status){
  this.selected.pop(id)
  }
  else{
      this.selected.push(id)
  }
},
   StatusSuccess() {
      this.$vs.notify({
        title: "Schedule",
        text: 'Schedule Deleted Successfully!',
        color: 'success',
        position: 'top-right'
      })
    },
    addNewData () {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    addNewCamUser (data) {
      this.camUserSidebarData = data
      this.toggleCamUserSidebar(true)
    },
     confirmDeleteRecord (schedule) {
      this.DeletedItem=schedule
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${schedule.name}"`,
        accept: this.deleteData,
        acceptText: 'Delete'
      })
    },
    deleteData () {
          for (let j = 0; j <this.DeletedItem.scheduledates.length; j++) {
            this.deletedschedules.push(this.DeletedItem.scheduledates[j].id)
          }
       this.$apollo
          .mutate({
           mutation: UPDATE_SCHEDULE,
          variables: {
          id:this.DeletedItem.id,
          name:this.DeletedItem.name,
          scheduledates: {
          update:[],
          create:[],
          delete:this.deletedschedules,
          },
          }
        })
        .then(response => {
        if (response){
        this.$apollo
        .mutate({
        mutation: REMOVE_SCHEDULE,
        variables: {
        id: response.data.updateSchedule.id,
        },
         })
      .then(response => {
        if (response.data.deleteSchedule.status='SUCCESS') {
          this.StatusSuccess()
          this.get()
        }
      })
      }
        }) .catch(error => {

          console.log(error)
      });
    },
    editData (data) {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    toggleCamUserSidebar (val = false) {
      this.addNewCamUserSidebar = val
    },
    get(){
      this.$apollo
      .mutate({
        mutation: ALL_SCHEDULE,
          variables: {
           status:1
     },
      })

      .then(response => {
        this.schedules=response.data.schedules
      })

    }
  },
  created () {
    this.get()
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .user_add_btn{
    float: right ;
    margin-top: -50px
  }
  @media (max-width: 461px) {
    .user_add_btn {
      margin-top: 60px
    }
  }
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
